import React from "react";
import AboutPage from "./AboutPage"; // Make sure this path is correct
import HeroComponent from "../minicomponents/HeroComponent";

function Home() {
  return (
    <>

      <HeroComponent />
      <section
        className="bg-gray-900 text-white pb-12 md:px-10 md:py-16"
        id="about"
      >
        <div className="max-w-5xl mx-auto">
          <AboutPage />
        </div>
      </section>

    </>
  );
}

export default Home;
